export default __webpack_public_path__ + "assets/orgauth-authing.9d8d29c7.png";